module.exports = __webpack_public_path__ + "img/2V.48c8e69d.jpg";